<template>
  <div>
    <AlertAuthError :error-message="errorText.message" :error-detail="errorText.detail" />
  </div>
</template>

<script>
import AlertAuthError from './AlertAuthError.vue';

export default {
  components: {
    AlertAuthError
  },
  props: {
    authType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      messageKey: {
        GOOGLE: {
          message: 'Email has already used to create account',
          detail: 'Try signing in with Google'
        },
        USER_PASSS: {
          message: 'Email has already used to create account',
          detail: 'Try signing in with email and password'
        }
      }
    };
  },
  computed: {
    errorText() {
      return this.messageKey[this.authType] ?? { message: null, detail: null };
    }
  }
};
</script>

<style lang="scss" scoped></style>
